export default __webpack_public_path__ + "static/media/jifen.a764d552.png";